import { error } from "ajv/dist/vocabularies/applicator/dependencies";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const ProductCreate = () => {
  const navigate = useNavigate();

  const sellerId = localStorage.getItem("seller_id");


  const initialFormState = {
    // Basic product fields
    product_name: "",
    current_price: "",
    old_price: "",
    prod_stock: "",
    rating: "",
    description: "",
    product_details: "",
    prod_vendor_assign: "",
    prod_size: "",
    status: "",
    discount_id: "",
    discount: "",
    // product_status:"",
    brand_id: "",

    // Category selectors
    main_category: "",
    sub_category: "",
    size_id: [],

    // Electronics fields
    company_name: "",
    model_name: "",
    ram: "",
    rom: "",
    processor: "",
    camera: "",
    battery: "",
    operating_system: "",
    available_colors: [],
    weight:"",
    dimension:"",
    paid_promo: "",

    // Fashion fields
    fashion_brand_name: "",
    material: "",
    fit_type: "",
    occasion: "",
    available_size: [],
    available_color: [],
    care_instructions: "",

    // images
    prod_image: null,
    prod_multi_images: [],
  };

  const [ProductUser, setProductUser] = useState(initialFormState);
  const [previewImage, setPreviewImage] = useState(null);
  const [multiPreview, setMultiPreview] = useState([]);
  const [CategoryUser, setCategoryUser] = useState([]);
  const [SubCategoryUser, setSubCategoryUser] = useState([]);
  const [Sizeuser, setSizeUser] = useState([]);
  const [ColorUser, setColorUser] = useState([]);
  const [DiscountUser, setDiscountUser] = useState([]);
  const [BrandUser, setBrandUser] = useState([]); // Added brand state
  const [isSizeDropdownOpen, setIsSizeDropdownOpen] = useState(false);
  const [isColorDropdownOpen, setIsColorDropdownOpen] = useState(false);
  const [isDiscountDropdownOpen, setIsDiscountDropdownOpen] = useState(false);
  const [isBrandDropdownOpen, setIsBrandDropdownOpen] = useState(false); // Added brand dropdown state

  // Generic input handler
  const handleInput = (e) => {
    const { name, value } = e.target;
    setProductUser((prev) => ({ ...prev, [name]: value }));
  };

  // Handle multi-select arrays
  const handleMultiSelect = (e, stateKey) => {
    const selected = Array.from(e.target.selectedOptions, (opt) => opt.value);
    setProductUser((prev) => ({ ...prev, [stateKey]: selected }));
  };

  const handleSizeCheckbox = (sizeId) => {
    setProductUser((prev) => {
      const currentSizes = prev.size_id || [];
      const sizeIdStr = String(sizeId);
      
      let updatedSizes;
      if (currentSizes.includes(sizeIdStr)) {
        updatedSizes = currentSizes.filter((id) => id !== sizeIdStr);
      } else {
        updatedSizes = [...currentSizes, sizeIdStr];
      }
      
      return {
        ...prev,
        size_id: updatedSizes,
        available_size: updatedSizes
      };
    });
  };

  const handleColorCheckbox = (colorId) => {
    setProductUser((prev) => {
      const currentColors = prev.available_color || [];
      const colorIdStr = String(colorId);
      
      if (currentColors.includes(colorIdStr)) {
        return {
          ...prev,
          available_color: currentColors.filter((id) => id !== colorIdStr)
        };
      } else {
        return {
          ...prev,
          available_color: [...currentColors, colorIdStr]
        };
      }
    });
  };

  // Handle brand radio selection
  const handleBrandRadio = (brandId) => {
    setProductUser((prev) => ({
      ...prev,
      brand_id: String(brandId)
    }));
  };

  // Handle multiple images
    const handleMultiImageChange = async (e) => {
      const files = Array.from(e.target.files || []);
      const validFiles = [];
      const previews = [];
  
      for (let file of files) {
        const info = await validateImage(file);
  
        if (!info.isSquare) {
          toast.warning(
            `${file.name} is ${info.width}×${info.height}. Image will be auto-adjusted.`
          );
        }
  
        validFiles.push(file);
        previews.push(URL.createObjectURL(file));
      }
  
      setProductUser((prev) => ({ ...prev, prod_multi_images: validFiles }));
      setMultiPreview(previews);
    };
  
  
    const validateImage = (file) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);
  
        img.onload = () => {
          const isSquare = img.width === img.height;
          resolve({
            width: img.width,
            height: img.height,
            isSquare
          });
        };
  
        img.onerror = () => reject("Invalid image");
      });
    };

  // Fetch categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_category"
        );
        setCategoryUser(res.data?.row || []);
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    const fetchSize = async () => {
      try {
        const response = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_mst_prod_size"
        );
        setSizeUser(response.data?.row || []);
      } catch (err) {
        console.error("Error fetching Sizes:", err);
      }
    };
    fetchSize();
  }, []);

  useEffect(() => {
    const fetchColour = async () => {
      try {
        const response = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_mst_prod_color"
        );
        setColorUser(response.data?.colors || []);
      } catch (err) {
        console.error("Error fetching Colours:", err);
      }
    };
    fetchColour();
  }, []);

  useEffect(() => {
    const fetchDiscount = async () => {
      try {
        const response = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/discount_list"
        );
        setDiscountUser(response.data?.data || []);
      } catch (err) {
        console.error("Error fetching Discounts:", err);
      }
    };
    fetchDiscount();
  }, []);

  // Fetch brands
  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/Brand_list"
        );
        setBrandUser(response.data?.data || []);
      } catch (err) {
        console.error("Error fetching Brands:", err);
      }
    };
    fetchBrands();
  }, []);

  useEffect(() => {
    const fetchSubcategories = async () => {
      if (!ProductUser.main_category) {
        setSubCategoryUser([]);
        return;
      }
      try {
        const res = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_subcategory"
        );
        const all = res.data?.row || [];
        const filtered = all.filter(
          (sub) => String(sub.category_id) === String(ProductUser.main_category)
        );
        setSubCategoryUser(filtered);
      } catch (err) {
        console.error("Error fetching subcategories:", err);
      }
    };
    fetchSubcategories();
  }, [ProductUser.main_category]);

  const submitForm = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();

      formData.append("seller_id", sellerId);
      formData.append("product_name", (ProductUser.product_name || "").trim());
      formData.append("current_price", (ProductUser.current_price || "").trim());
      formData.append("old_price", (ProductUser.old_price || "").trim());
      formData.append("stock", (ProductUser.prod_stock || "").trim());
      formData.append("rating", (ProductUser.rating || "").trim());
      formData.append("description", (ProductUser.description || "").trim());
      formData.append("product_details", (ProductUser.product_details || "").trim());
      formData.append("assign_vendor", (ProductUser.prod_vendor_assign || "").trim());
      formData.append("size", (ProductUser.prod_size || "").trim());
      formData.append("weight", (ProductUser.weight || "").trim());
      formData.append("dimension", (ProductUser.dimension || "").trim());
      formData.append("paid_promo", ProductUser.paid_promo || "");
      
      let mappedStatus = "Out of Stock";
      if (ProductUser.status === "Instock") mappedStatus = "In Stock";
      if (ProductUser.status === "Outofstock") mappedStatus = "Out of Stock";
      if (ProductUser.status === "fewleft") mappedStatus = "Few Left";
      formData.append("status", mappedStatus);

      // formData.append("product_status", ProductUser.product_status || "");
      formData.append("category_id", ProductUser.main_category || "");
      formData.append("subcategory_id", ProductUser.sub_category || "");
      formData.append("brand_id", ProductUser.brand_id || ""); // Added brand_id
      
      formData.append(
        "size_id",
        Array.isArray(ProductUser.size_id)
          ? ProductUser.size_id.join(",")
          : ProductUser.size_id || ""
      );

      formData.append("company_name", ProductUser.company_name || "");
      formData.append("model_name", ProductUser.model_name || "");
      formData.append("ram", ProductUser.ram || "");
      formData.append("rom", ProductUser.rom || "");
      formData.append("processor", ProductUser.processor || "");
      formData.append("camera", ProductUser.camera || "");
      formData.append("battery", ProductUser.battery || "");
      formData.append("operating_system", ProductUser.operating_system || "");

      formData.append("fashion_brand_name", ProductUser.fashion_brand_name || "");
      formData.append("material", ProductUser.material || "");
      formData.append("fit_type", ProductUser.fit_type || "");
      formData.append("occasion", ProductUser.occasion || "");
      formData.append(
        "available_size",
        Array.isArray(ProductUser.available_size)
          ? ProductUser.available_size.join(",")
          : ProductUser.available_size || ""
      );
      formData.append(
        "available_color",
        Array.isArray(ProductUser.available_color)
          ? ProductUser.available_color.join(",")
          : ProductUser.available_color || ""
      );
      formData.append("care_instructions", ProductUser.care_instructions || "");
      formData.append("discount_id", ProductUser.discount_id || "");
      formData.append("discount", ProductUser.discount || "");

      if (Array.isArray(ProductUser.prod_multi_images) && ProductUser.prod_multi_images.length) {
        ProductUser.prod_multi_images.forEach((file) => {
          formData.append("multi_image[]", file);
        });
      }

      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_create_product",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      const data = response.data;
      const success =
        data?.status === true || data?.success === "1" || data?.status === "true";

      if (success) {
        toast.success(data?.message || "Product added successfully!");
        setProductUser(initialFormState);
        setPreviewImage(null);
        setMultiPreview([]);
        navigate("/product-list");
      } else {
        toast.error(data?.message || "Failed to add product");
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Something went wrong!");
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Create Product</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">Product</li>
                <li className="breadcrumb-item active">Create Product</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Form Section */}
        <div className="row">
          <div className="col-xl-9 col-lg-8">
            <form onSubmit={submitForm}>
              {/* Image Upload */}
              <div className="card mb-3">
                <div className="card-header">
                  <h4 className="card-title">Add Product Photo</h4>
                </div>
                <div className="card-body">
                  <label className="form-label text-dark">Product Multiple Images</label>
                  <input
                    type="file"
                    multiple
                    className="form-control"
                    accept=".png,.webp"
                    onChange={handleMultiImageChange}
                  />

                  <small className="text-muted d-block mt-1">
                    Recommended image size: <b>2000 × 2000 px (1:1 square)</b><br />
                    Supported formats: <b>.webp, .png</b><br />
                    Background: plain or transparent<br />
                    Max size: 500 KB per image
                  </small>

                  <div className="d-flex gap-2 mt-2">
                    {multiPreview.map((p, i) => (
                      <img
                        key={i}
                        src={p}
                        alt={`multi-${i}`}
                        className="product-preview"
                      />
                    ))}
                  </div>
                </div>
              </div>

              {/* Product Info */}
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Product Information</h4>
                </div>
                <div className="card-body">
                  <div className="row g-3">
                    <div className="col-lg-6">
                      <label className="form-label">Product Name</label>
                      <input
                        type="text"
                        name="product_name"
                        value={ProductUser.product_name}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Enter product name"
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Current Price</label>
                      <input
                        type="number"
                        name="current_price"
                        value={ProductUser.current_price}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="000"
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Old Price</label>
                      <input
                        type="number"
                        name="old_price"
                        value={ProductUser.old_price}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="000"
                      />
                    </div>

                    {/* CATEGORY SELECTION */}
                    <div className="col-lg-6">
                      <label className="form-label">Main Category</label>
                      <select
                        className="form-control"
                        name="main_category"
                        value={ProductUser.main_category}
                        onChange={(e) =>
                          setProductUser((prev) => ({
                            ...prev,
                            main_category: e.target.value,
                            sub_category: "",
                          }))
                        }
                      >
                        <option value="">-- Select Main Category --</option>
                        {CategoryUser.map((item) => (
                          <option key={item.category_id} value={String(item.category_id)}>
                            {item.category_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* SUBCATEGORY */}
                    {ProductUser.main_category && (
                      <div className="col-lg-6">
                        <label className="form-label">Subcategory</label>
                        <select
                          className="form-control"
                          name="sub_category"
                          value={ProductUser.sub_category}
                          onChange={handleInput}
                        >
                          <option value="">-- Select Subcategory --</option>
                          {SubCategoryUser.map((item) => (
                            <option key={item.subcategory_id} value={String(item.subcategory_id)}>
                              {item.subcategory_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    {/* BRAND SELECTION WITH RADIO BUTTONS */}
                    <div className="col-lg-6">
                      <label className="form-label">Product Brand</label>
                      <div className="position-relative">
                        <div
                          className="form-control d-flex justify-content-between align-items-center"
                          style={{ cursor: "pointer" }}
                          onClick={() => setIsBrandDropdownOpen(!isBrandDropdownOpen)}
                        >
                          <span>
                            {ProductUser.brand_id
                              ? BrandUser.find(b => String(b.brand_id) === String(ProductUser.brand_id))?.brand_name || "Select brand"
                              : "Select brand"}
                          </span>
                          <span>{isBrandDropdownOpen ? "▲" : "▼"}</span>
                        </div>
                        
                        {isBrandDropdownOpen && (
                          <div
                            className="border rounded bg-white position-absolute w-100 mt-1"
                            style={{
                              maxHeight: "250px",
                              overflowY: "auto",
                              zIndex: 1000,
                              boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
                            }}
                          >
                            <div className="p-3">
                              {BrandUser.length > 0 ? (
                                BrandUser.filter(brand => brand.status === "active").map((brand) => (
                                  <div key={brand.brand_id} className="form-check mb-2">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="brand_selection"
                                      id={`brand-${brand.brand_id}`}
                                      checked={String(ProductUser.brand_id) === String(brand.brand_id)}
                                      onChange={() => {
                                        handleBrandRadio(brand.brand_id);
                                        setIsBrandDropdownOpen(false);
                                      }}
                                    />
                                    <label className="form-check-label" htmlFor={`brand-${brand.brand_id}`}>
                                      <div className="fw-semibold">{brand.brand_name}</div>
                                      <small className="text-muted">{brand.manuf_name}</small>
                                    </label>
                                  </div>
                                ))
                              ) : (
                                <p className="text-muted mb-0">No brands available</p>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* SIZE SELECTION WITH CHECKBOXES */}
                    <div className="col-lg-6">
                      <label className="form-label">Product Sizes</label>
                      <div className="position-relative">
                        <div
                          className="form-control d-flex justify-content-between align-items-center"
                          style={{ cursor: "pointer" }}
                          onClick={() => setIsSizeDropdownOpen(!isSizeDropdownOpen)}
                        >
                          <span>
                            {ProductUser.size_id && ProductUser.size_id.length > 0
                              ? `${ProductUser.size_id.length} size(s) selected`
                              : "Select sizes"}
                          </span>
                          <span>{isSizeDropdownOpen ? "▲" : "▼"}</span>
                        </div>
                        
                        {isSizeDropdownOpen && (
                          <div
                            className="border rounded bg-white position-absolute w-100 mt-1"
                            style={{
                              maxHeight: "200px",
                              overflowY: "auto",
                              zIndex: 1000,
                              boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
                            }}
                          >
                            <div className="p-3">
                              {Sizeuser.length > 0 ? (
                                Sizeuser.map((size) => (
                                  <div key={size.size_id} className="form-check mb-2">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={`size-${size.size_id}`}
                                      checked={(ProductUser.size_id || []).includes(String(size.size_id))}
                                      onChange={() => handleSizeCheckbox(size.size_id)}
                                    />
                                    <label className="form-check-label" htmlFor={`size-${size.size_id}`}>
                                      {size.size_label || size.size}
                                    </label>
                                  </div>
                                ))
                              ) : (
                                <p className="text-muted mb-0">No sizes available</p>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* COLOR SELECTION WITH CHECKBOXES */}
                    <div className="col-lg-6">
                      <label className="form-label">Product Colors</label>
                      <div className="position-relative">
                        <div
                          className="form-control d-flex justify-content-between align-items-center"
                          style={{ cursor: "pointer" }}
                          onClick={() => setIsColorDropdownOpen(!isColorDropdownOpen)}
                        >
                          <span>
                            {ProductUser.available_color && ProductUser.available_color.length > 0
                              ? `${ProductUser.available_color.length} color(s) selected`
                              : "Select colors"}
                          </span>
                          <span>{isColorDropdownOpen ? "▲" : "▼"}</span>
                        </div>
                        
                        {isColorDropdownOpen && (
                          <div
                            className="border rounded bg-white position-absolute w-100 mt-1"
                            style={{
                              maxHeight: "200px",
                              overflowY: "auto",
                              zIndex: 1000,
                              boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
                            }}
                          >
                            <div className="p-3">
                              {ColorUser.length > 0 ? (
                                ColorUser.map((color) => (
                                  <div key={color.color_id} className="form-check mb-2 d-flex align-items-center">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={`color-${color.color_id}`}
                                      checked={(ProductUser.available_color || []).includes(String(color.color_id))}
                                      onChange={() => handleColorCheckbox(color.color_id)}
                                    />
                                    <label className="form-check-label d-flex align-items-center" htmlFor={`color-${color.color_id}`}>
                                      <span
                                        className="d-inline-block me-2 ms-2"
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                          backgroundColor: color.code,
                                          border: "1px solid #ddd",
                                          borderRadius: "3px"
                                        }}
                                      ></span>
                                      {color.color_name}
                                    </label>
                                  </div>
                                ))
                              ) : (
                                <p className="text-muted mb-0">No colors available</p>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* ELECTRONICS BLOCK */}
                    {String(ProductUser.main_category) === "1" && (
                      <>
                        <hr className="mt-4 mb-2" />
                        <h5 className="text-primary">Electronics Specifications</h5>

                        <div className="col-lg-6">
                          <label className="form-label">Company Name</label>
                          <input
                            type="text"
                            name="company_name"
                            value={ProductUser.company_name}
                            onChange={handleInput}
                            className="form-control"
                            placeholder="e.g. Apple"
                          />
                        </div>

                        <div className="col-lg-6">
                          <label className="form-label">Model Name</label>
                          <input
                            type="text"
                            name="model_name"
                            value={ProductUser.model_name}
                            onChange={handleInput}
                            className="form-control"
                            placeholder="e.g. iPhone 16"
                          />
                        </div>

                        <div className="col-12">
                          <label className="form-label">Specifications</label>
                          <div className="row g-3">
                            <div className="col-lg-4">
                              <input
                                type="text"
                                name="ram"
                                value={ProductUser.ram}
                                onChange={handleInput}
                                className="form-control"
                                placeholder="RAM (e.g. 8GB)"
                              />
                            </div>
                            <div className="col-lg-4">
                              <input
                                type="text"
                                name="rom"
                                value={ProductUser.rom}
                                onChange={handleInput}
                                className="form-control"
                                placeholder="ROM (e.g. 128GB)"
                              />
                            </div>
                            <div className="col-lg-4">
                              <input
                                type="text"
                                name="processor"
                                value={ProductUser.processor}
                                onChange={handleInput}
                                className="form-control"
                                placeholder="Processor"
                              />
                            </div>
                            <div className="col-lg-4">
                              <input
                                type="text"
                                name="camera"
                                value={ProductUser.camera}
                                onChange={handleInput}
                                className="form-control"
                                placeholder="Camera"
                              />
                            </div>
                            <div className="col-lg-4">
                              <input
                                type="text"
                                name="battery"
                                value={ProductUser.battery}
                                onChange={handleInput}
                                className="form-control"
                                placeholder="Battery (mAh)"
                              />
                            </div>
                            <div className="col-lg-4">
                              <input
                                type="text"
                                name="operating_system"
                                value={ProductUser.operating_system}
                                onChange={handleInput}
                                className="form-control"
                                placeholder="Operating System"
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    {/* FASHION BLOCK */}
                    {String(ProductUser.main_category) === "2" && (
                      <>
                        <hr className="mt-4 mb-2" />
                        <h5 className="text-primary">Fashion Specifications</h5>

                        <div className="col-lg-6">
                          <label className="form-label">Brand Name</label>
                          <input
                            type="text"
                            name="fashion_brand_name"
                            value={ProductUser.fashion_brand_name}
                            onChange={handleInput}
                            className="form-control"
                            placeholder="Enter brand name (e.g. Levi's)"
                          />
                        </div>

                        <div className="col-lg-6">
                          <label className="form-label">Material</label>
                          <input
                            type="text"
                            name="material"
                            value={ProductUser.material}
                            onChange={handleInput}
                            className="form-control"
                            placeholder="e.g. Cotton"
                          />
                        </div>

                        <div className="col-lg-6">
                          <label className="form-label">Fit Type</label>
                          <input
                            type="text"
                            name="fit_type"
                            value={ProductUser.fit_type}
                            onChange={handleInput}
                            className="form-control"
                            placeholder="e.g. Regular Fit"
                          />
                        </div>

                        <div className="col-lg-6">
                          <label className="form-label">Occasion</label>
                          <input
                            type="text"
                            name="occasion"
                            value={ProductUser.occasion}
                            onChange={handleInput}
                            className="form-control"
                            placeholder="e.g. Casual"
                          />
                        </div>

                        <div className="col-lg-6">
                          <label className="form-label">Care Instructions</label>
                          <input
                            type="text"
                            name="care_instructions"
                            value={ProductUser.care_instructions}
                            onChange={handleInput}
                            className="form-control"
                            placeholder="e.g. Machine wash cold"
                          />
                        </div>
                      </>
                    )}

                    {/* Common remaining fields */}
                    <div className="col-lg-6">
                      <label className="form-label">Stock</label>
                      <input
                        type="text"
                        name="prod_stock"
                        value={ProductUser.prod_stock}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Enter stock quantity"
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Rating</label>
                      <input
                        type="text"
                        name="rating"
                        value={ProductUser.rating}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Enter rating (e.g. 4.5)"
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Apply Discount</label>
                      <div className="position-relative">
                        <div
                          className="form-control d-flex justify-content-between align-items-center"
                          style={{ cursor: "pointer" }}
                          onClick={() => setIsDiscountDropdownOpen(!isDiscountDropdownOpen)}
                        >
                          <span>
                            {ProductUser.discount_id
                              ? DiscountUser.find(d => String(d.disc_id) === String(ProductUser.discount_id))?.disc_name
                              : "Select discount"}
                          </span>
                          <span>{isDiscountDropdownOpen ? "▲" : "▼"}</span>
                        </div>

                        {isDiscountDropdownOpen && (
                          <div
                            className="border rounded bg-white position-absolute w-100 mt-1"
                            style={{
                              maxHeight: "250px",
                              overflowY: "auto",
                              zIndex: 1000,
                              boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
                            }}
                          >
                            <div className="p-2">
                              <div
                                className="p-2 hover-bg-light"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setProductUser(prev => ({
                                    ...prev,
                                    discount_id: "",
                                    discount: ""
                                  }));
                                  setIsDiscountDropdownOpen(false);
                                }}
                              >
                                <small className="text-muted">No Discount</small>
                              </div>

                              {DiscountUser.length > 0 ? (
                                DiscountUser.filter(disc => disc.status === "1").map((item) => (
                                  <div
                                    key={item.disc_id}
                                    className="p-2 border-bottom hover-bg-light"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setProductUser(prev => ({
                                        ...prev,
                                        discount_id: item.disc_id,
                                        discount: item.disc_amount
                                      }));
                                      setIsDiscountDropdownOpen(false);
                                    }}
                                  >
                                    <div className="d-flex justify-content-between align-items-start">
                                      <div>
                                        <div className="fw-semibold">{item.disc_name}</div>
                                        <small className="text-muted">
                                          {item.disc_start_date} to {item.disc_end_date}
                                        </small>
                                      </div>
                                      <span className="badge bg-success">₹{item.disc_amount} OFF</span>
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <p className="text-muted mb-0 p-2">No active discounts available</p>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Description</label>
                      <input
                        type="text"
                        name="description"
                        value={ProductUser.description}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Short product description"
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Product Details</label>
                      <input
                        type="text"
                        name="product_details"
                        value={ProductUser.product_details}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Additional details"
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Weight</label>
                      <input
                        type="text"
                        name="weight"
                        value={ProductUser.weight}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Enter weight"
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Dimension</label>
                      <input
                        type="text"
                        name="dimension"
                        value={ProductUser.dimension}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Enter Dimension"
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Assign Vendor</label>
                      <select
                        className="form-control"
                        name="prod_vendor_assign"
                        value={ProductUser.prod_vendor_assign}
                        onChange={handleInput}
                      >
                        <option value="">Select Vendor</option>
                        <option value="H&M">H&M</option>
                        <option value="Nike">Nike</option>
                        <option value="Zara">Zara</option>
                      </select>
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Paid Promotion</label>
                      <select
                        className="form-control"
                        name="paid_promo"
                        value={ProductUser.paid_promo}
                        onChange={handleInput}
                      >
                        <option value="">-- Select Paid Promotion --</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div> 

                    <div className="col-lg-6">
                      <label className="form-label">Status</label>
                      <select
                        className="form-control"
                        name="status"
                        value={ProductUser.status}
                        onChange={handleInput}
                      >
                        <option value="">-- Select Status --</option>
                        <option value="Instock">In stock</option>
                        <option value="Outofstock">Out of stock</option>
                        <option value="fewleft">Few left</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="p-3 bg-light mb-3 rounded">
                <div className="row justify-content-end g-2">
                  <div className="col-lg-2">
                    <button type="submit" className="btn btn-outline-secondary w-100">
                      Create Product
                    </button>
                  </div>
                  <div className="col-lg-2">
                    <Link to="/product-list" className="btn btn-primary w-100">
                      Cancel
                    </Link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="container-fluid text-center py-3">
          © Venton. Crafted by{" "}
          <span className="text-danger">❤️</span> <strong>Techzaa</strong>
        </div>
      </footer>
    </div>
  );
};

export default ProductCreate;